import { render, staticRenderFns } from "./ConnectionDetailsView.vue?vue&type=template&id=e1837040"
import script from "./ConnectionDetailsView.vue?vue&type=script&lang=js"
export * from "./ConnectionDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports